/* eslint-disable */
import { useEffect,useContext } from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Drawer from '@mui/material/Drawer';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import { alpha } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import ListItemButton from '@mui/material/ListItemButton';

import { NAV } from './config-layout';
import navConfig from './config-navigation';
import Scrollbar from '../../components/scrollbar';
import Logo from '../../components/logo';
import { AuthContext } from '../../context/AuthContext';
import { useResponsive } from '../../hooks/use-responsive';
import { usePathname } from '../../routes/hooks';
import { RouterLink } from '../../routes/components';

// ----------------------------------------------------------------------

export default function Nav({ openNav, onCloseNav }) {
  const pathname = usePathname();

  const upLg = useResponsive('up', 'lg');
  const { user } = useContext(AuthContext);

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const renderAccount = (
    <Box
      sx={{
        my: 3,
        mx: 2.5,
        py: 2,
        px: 2.5,
        display: 'flex',
        borderRadius: 1.5,
        alignItems: 'center',
        backgroundColor:"#ffffff30",
        // bgcolor: (theme) => alpha(theme.palette.grey[500], 0.12),
      }}
    >
      <Avatar src={user.image} alt={user.username} />

      <Box sx={{ ml: 2 }}>
        <Typography variant="subtitle2">{user.firstName} {user.lastName}</Typography>

        <Typography variant="body2" sx={{ color: '#fff',fontWeight:600 }}>
          Admin
        </Typography>
      </Box>
    </Box>
  );

  const renderMenu = (
    <Stack component="nav" spacing={0.5} sx={{ px: 2 }}>
      {navConfig.map((item) => (
        <NavItem key={item.title} item={item} />
      ))}
    </Stack>
  );

  

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        '& .simplebar-content': {
          height: 1,
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <Logo sx={{ py: 2, justifyContent:"center" , background:"linear-gradient(151.55deg, #1088d3 1.48%, #0546a9 97.04%)"}} />

      {renderAccount}

      {renderMenu}

      <Box sx={{ flexGrow: 1 }} />

    </Scrollbar>
  );

  return (
    <Box
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.WIDTH },
      }}
    >
      {upLg ? (
        <Box
          sx={{
            height: 1,
            position: 'fixed',
            width: NAV.WIDTH,
            background: 'linear-gradient(151.55deg, #009AFE 1.48%, #006AFE 97.04%)'
            // borderRight: (theme) => `dashed 1px ${theme.palette.divider}`,
          }}
        >
          {renderContent}
        </Box>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          PaperProps={{
            sx: {
              width: NAV.WIDTH,
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}

Nav.propTypes = {
  openNav: PropTypes.bool,
  onCloseNav: PropTypes.func,
};

// ----------------------------------------------------------------------

function NavItem({ item }) {
  const pathname = usePathname();

  const active = item.path === pathname;

  return (
    <ListItemButton
      component={RouterLink}
      href={item.path}
      sx={{
        minHeight: 44,
        borderRadius: 0.75,
        typography: 'body2',
        color: '#fff',
        textTransform: 'capitalize',
        '&:hover': {
            background:'linear-gradient(88deg, #1e77fe 20%, #0549ab 110%) !important',
          },
        fontWeight: 'fontWeightMedium',
        ...(active && {
          color: '#fff',
          fontWeight: 'fontWeightSemiBold',
          backgroundColor:"#FF9C1A",
          '&:hover': {
            background:'linear-gradient(88deg, #1e77fe 20%, #0549ab 110%) !important',
          },
        }),
      }}
    >
      <Box component="span" sx={{ width: 24, height: 24, mr: 2 }}>
        {item.icon}
      </Box>

      <Box component="span">{item.title} </Box>
    </ListItemButton>
  );
}

NavItem.propTypes = {
  item: PropTypes.object,
};
